import { Box, Heading, Icon, Image, Paragraph } from '@zillow/constellation-10';
import { IconHammerOutline, IconHouseOutline, IconUserAddOutline } from '@zillow/constellation-icons';
import HouseWithSignAndRealtorInFront from '../../../../../images/houseWithSignAndRealtorInFront.svg';

export default function StepsToTakeToFindYourNextTenants() {
  return (
    <>
      <Image src={HouseWithSignAndRealtorInFront} alt="house with sign and realtor in front" />
      <Heading
        level={2}
        fontFamily="heading-alt"
        css={{ textStyle: 'responsive.heading-md', marginBottom: 'looser', marginTop: 'tight' }}
      >
        Steps to take to find your next tenants
      </Heading>
      <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'looser' }}>
        <Icon css={{ flexShrink: 0 }} size="lg">
          <IconUserAddOutline />
        </Icon>
        <div>
          <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
            Use Zillow’s rental applications
          </Heading>
          <Paragraph css={{ color: 'text.secondary' }}>
            It’s free for landlords and makes reviewing prospective tenants a breeze
          </Paragraph>
        </div>
      </Box>
      <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'looser' }}>
        <Icon css={{ flexShrink: 0 }} size="lg">
          <IconHammerOutline />
        </Icon>
        <div>
          <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
            Manage any maintenance needs
          </Heading>
          <Paragraph css={{ color: 'text.secondary' }}>
            Use the time between tenants as an opportunity to address bigger repairs
          </Paragraph>
        </div>
      </Box>
      <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'looser' }}>
        <Icon css={{ flexShrink: 0 }} size="lg">
          <IconHouseOutline />
        </Icon>
        <div>
          <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
            Update your listing
          </Heading>
          <Paragraph css={{ color: 'text.secondary' }}>
            Consider refreshing your photos and details to show off any improvements
          </Paragraph>
        </div>
      </Box>
    </>
  );
}
